import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconEnvelopRoundFill = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.008 7.5a2.5 2.5 0 0 1 2.5-2.5h13a2.5 2.5 0 0 1 2.5 2.5v9a2.5 2.5 0 0 1-2.5 2.5h-13a2.5 2.5 0 0 1-2.5-2.5v-9Zm15.754 3.685a1 1 0 0 0-1.2-1.6l-5.254 3.94a.5.5 0 0 1-.6 0l-5.254-3.94a1 1 0 1 0-1.2 1.6l5.254 3.94a2.5 2.5 0 0 0 3 0l5.254-3.94Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconEnvelopRoundFill);
export default Memo;
